<div style="position: relative">
  <div id="front" [ngStyle]="style"></div>
  <div *ngIf="fullScreen" id="metaData" [ngStyle]="styleMeta">
    <mat-list>
      <ng-container [ngSwitch]="meta?.label">
        <ng-container *ngSwitchCase="'person'">
          <mat-list-item>Person</mat-list-item>
          <mat-list-item>Confidence: {{ meta?.confidence | fsNumber : '1.0-2' }}%</mat-list-item>
          <ng-container *ngIf="meta.metadata?.age">
            <mat-list-item>
              <div mat-line>Age: {{ meta.metadata?.age?.label?.toUpperCase() }}</div>
              <div class="propertyName" mat-line>
                Confidence:
                {{ meta.metadata?.age?.confidence | fsNumber : '1.0-2' }}%
              </div>
            </mat-list-item>
          </ng-container>
          <ng-container *ngIf="meta.metadata?.colorTop">
            <mat-list-item>
              <div mat-line>Top Color: {{ meta.metadata?.colorTop?.label?.toUpperCase() }}</div>
            </mat-list-item>
          </ng-container>
          <ng-container *ngIf="meta.metadata?.colorBottom">
            <mat-list-item>
              <div mat-line>
                Bottom Color:
                {{ meta.metadata?.colorBottom?.label?.toUpperCase() }}
              </div>
            </mat-list-item>
          </ng-container>
          <mat-list-item *ngFor="let property of formatFields(meta.metadata?.attributes)">
            <div mat-line>{{ toStartCase(property.label).toUpperCase() }}</div>
            <div class="propertyName" mat-line>
              Confidence: {{ property.confidence | fsNumber : '1.0-2' }}%
            </div>
          </mat-list-item>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <mat-list-item> Vehicle </mat-list-item>
          <mat-list-item *ngFor="let property of formatFields(meta?.metadata) | keyvalue">
            <ng-container ngProjectAs="[mat-line]" *ngIf="isArray(property.value)">
              <ng-container *ngFor="let item of property.value">
                <ng-container *ngIf="isObject(item)">
                  <ng-container *ngFor="let itemObject of item | keyvalue">
                    <div class="propertyName" mat-line>
                      {{ itemObject.key }}: {{ itemObject.value }}
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngif="!isObject(item)">
                  {{ item }}
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container ngProjectAs="[mat-line]" *ngIf="!isArray(property.value)">
              <ng-container
                ngProjectAs="[mat-line]"
                *ngIf="property.key === 'vehicleLicensePlate'; else default"
              >
                <div mat-line>
                  {{ property.value[0]?.plate[0]?.label.toUpperCase() }} -
                  {{ property.value[0]?.state[0]?.label.toUpperCase() }}
                </div>
                <div class="propertyName" mat-line>{{ toStartCase(property.key) }}</div>
              </ng-container>

              <ng-template ngProjectAs="[mat-line]" #default>
                <div class="propertyName" mat-line>
                  {{ toStartCase(property.key) }}: {{ property.value }}
                </div>
              </ng-template>
            </ng-container>
          </mat-list-item>
        </ng-container>
      </ng-container>
    </mat-list>
  </div>
  <div id="back"><ng-content></ng-content></div>
</div>
